import { render, staticRenderFns } from "./inbound-call-abandoned-icon.vue?vue&type=template&id=3176ec6a"
import script from "./inbound-call-abandoned-icon.vue?vue&type=script&lang=js"
export * from "./inbound-call-abandoned-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports